// MASTERS TYPES
const MastersTypesData = {
    INDUSTRY_TYPE: 'Industry Type',
    OCCUPATION: 'Occupation',
    EDUCATION_QUALIFICATION: 'Education Qualification',
    INSURANCE_PLANS: "Insurance Plans",
    POLICY_TYPE: "Policy Type",
    RTO_ZONE: "RTO State"
};

export const MASTERS_TYPES = {};

export const MASTERS_TYPES_LIST = Object.keys(
    MastersTypesData,
).map((key) => {
    MASTERS_TYPES[key] = key;

    return {
        value: key,
        label: MastersTypesData[key],
    };
});

export default {
    MASTERS_TYPES,
    MASTERS_TYPES_LIST,
    MastersTypesData,
};
